export default __webpack_public_path__ + "static/media/topic-background-small.e8726c47.svg";